<div class="app-input-dropdown">
  <div *ngIf="disabled" class="app-input-dropdown-disabled-overlay"></div>
    <div [ngClass]="{'inline-form-field': inline}">
    <label *ngIf="label" class="app-input-dropdown-label"
      >{{ label }}
      <ng-container *ngIf="isRequired">*</ng-container>

      <i
        style="padding-left: 5px"
        tooltipPosition="top"
        pTooltip="{{ tooltip }}"
        *ngIf="tooltip"
        class="fa-solid fa-circle-question text-link-color"
      ></i>
    </label>    

    <p-select [appendTo]="appendTo" ngDefaultControl [ngClass]="{ 'full-width': shouldBeFullWidth }" [placeholder]="placeholder" [options]="options" [formControl]="control"
    optionValue="value" 
    optionDisabled="disabled"

    >
  
    <ng-template #selectedItem let-selectedOption>
      {{selectedOption.text}}
    </ng-template>

    <ng-template let-op #item>
      {{op.text}}
    </ng-template>
  
  </p-select>
  </div>
</div>
